import fetch from '@/utils/fetch'

export const List = '/order/voucher/list'

/** 导出 */
export function handleExport (query) {
  return fetch({
    url: List,
    method: 'get',
    params: query
  })
}
